
import { createRouter, createMemoryHistory, useRoute } from 'vue-router';


const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../pages/home.vue')
    },
]
const router = createRouter({
    history: createMemoryHistory(),
    scrollBehavior: () => {
        return {left: 0, top: 0}
    },
    isAddDynamicMenuRoutes: true, // 是否添加动态菜单路由
    routes
})

export default router;